import { render } from "./InstanceLeftMenu.vue?vue&type=template&id=4e7e2be1"
import script from "./InstanceLeftMenu.vue?vue&type=script&lang=js"
export * from "./InstanceLeftMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__